module.exports = __webpack_public_path__ + "img/lipscombhall-h-474x356.3760e960.jpg";